// TODO 所有useradmin界面加输入检测
// TODO 所有useradmin界面检查需要是否需用hint
// TODO 所有useradmin界面加输入框字数限制
// TODO 修改密码逻辑
import uniqBy from 'lodash/uniqBy'
import {Person, Group, Role, LError, Permission, Institution, GroupType} from '../../object'
import {getField, updateField} from 'vuex-map-fields'
import Vue from 'vue'
import axios from 'axios'
import {handleError} from '../handleError'

const state = {
  newUserData: new Person(),
  groupTypes: []
}
const getters = {
  getField,
  getNewPerson: () => () => {
    return new Person()
  }
}

// 转换接口

const mutations = {
  updateField,
  setTest (state, val) {
    state.test = val
  },
  setTestAttr (state, {key, value}) {
    if (key) {
      Vue.set(state.test, key, value)
    }
  },
  saveGroupTypes (state, val) {
    state.groupTypes = val
  },
  changeGroupType (state, type) {
    let i = state.groupTypes.findIndex(t => t.id === type.id)
    if (i >= 0) {
      state.groupTypes.splice(i, 1, type)
    }
  }
}

const actions = {
  // User
  async getUsers ({dispatch}, {pagination, filter, sortStack, search}) {
    let {items, amount} = await dispatch('getDataList', {
      pagination,
      sortStack,
      search,
      filter,
      transDict: {phone: 'mobilePhone'},
      url: `/shiroApi/user/list`
    }, {root: true})
    return {items: items.map(t => Person.fromAPI(t)), amount: amount}
  },
  async getVisitorUsers ({dispatch}, {pagination, filter, sortStack, search}) {
    let {items, amount} = await dispatch('getDataList', {
      pagination,
      sortStack,
      filter,
      url: `/passObjectApi/order/getVisitorList`
    }, {root: true})
    return {items: items, amount: amount}
  },
  async setUser ({dispatch}, {id = '', name, loginId, password, phone, email, extendSubmit}) {
    let data = await dispatch('getDataFromApi', {
      method: 'put',
      data: {
        'id': id,
        'loginId': loginId,
        'name': name,
        'password': password,
        'mobilePhone': phone,
        'email': email,
        'extend': extendSubmit
      },
      url: '/shiroApi/user/'
    }, {root: true})
    return new Person(data)
  },
  async deleteUsers ({dispatch}, users) {
    let ids
    if (users instanceof Array) {
      ids = users.filter(p => p instanceof Person).map(p => p.id)
    }
    else if (users instanceof Person) {
      ids = [users.id]
    }
    else {
      return
    }
    return dispatch('getDataFromApi', {
      method: 'delete',
      data: {
        ids: ids
      },
      url: '/shiroApi/user/'
    }, {root: true})
  },
  async userBindRoles ({dispatch}, {user, roles = []}) {
    if (user) {
      let ps = uniqBy([...user.roleList, ...roles], 'id')
      return dispatch('getDataFromApi', {
        url: `/shiroApi/user/${user.id}/bind/role`,
        method: 'put',
        data: {
          roleIds: ps.map(p => p.id)
        }
      }, {root: true})
    }
  },
  async userUnbindRole ({dispatch}, {user, role}) {
    if (role && user) {
      let ps = user.roleList.filter(p => p.id !== role.id)
      // console.log('filter', ps)
      return dispatch('getDataFromApi', {
        url: `/shiroApi/user/${user.id}/bind/role`,
        method: 'put',
        data: {
          roleIds: ps.map(p => p.id)
        }
      }, {root: true})
    }
    else {
      throw new LError('解除绑定失败，未获取到用户ID或角色ID')
    }
  },
  async userUser ({dispatch}, loginId) {
    if (role && user) {
      let ps = user.roleList.filter(p => p.id !== role.id)
      // console.log('filter', ps)
      return dispatch('getDataFromApi', {
        url: `/shiroApi/user/${user.id}/bind/role`,
        method: 'put',
        data: {
          roleIds: ps.map(p => p.id)
        }
      }, {root: true})
    }
    else {
      throw new LError('解除绑定失败，未获取到用户ID或角色ID')
    }
  },
  async userBindGroups ({dispatch}, {user, groups = []}) {
    if (user) {
      let ps = uniqBy([...user.groupList, ...groups], 'id')
      return dispatch('getDataFromApi', {
        url: `/shiroApi/user/${user.id}/bind/group`,
        method: 'put',
        data: {
          groupIds: ps.map(p => p.id)
        }
      }, {root: true})
    }
  },
  async userUnbindGroups ({dispatch}, {user, groups}) {
    if (groups instanceof Array && groups.length && user) {
      let ps = user.groupList.filter(p => groups.every(g => g.id !== p.id))
      return dispatch('getDataFromApi', {
        url: `/shiroApi/user/${user.id}/bind/group`,
        method: 'put',
        data: {
          groupIds: ps.map(p => p.id)
        }
      }, {root: true})
    }
    else {
      throw new LError('解除绑定失败，未获取到用户ID或分组ID')
    }
  },

  // GroupType
  async getGroupTypes ({dispatch, commit}, {pagination, filter, sortStack, search}) {
    let {items, amount} = await dispatch('getDataList', {
      pagination,
      sortStack,
      search,
      filter,
      url: `/shiroApi/group/type/list`
    }, {root: true})

    let types = items.map(t => GroupType.fromAPI(t))
    commit('saveGroupTypes', types)

    return {items: types, amount: amount}
  },
  async setGroupType ({dispatch, commit}, {id = '', name, description}) {
    let data = await dispatch('getDataFromApi', {
      method: 'put',
      data: {
        'id': id,
        'name': name,
        'description': description
      },
      url: '/shiroApi/group/type'
    }, {root: true})
    let type = GroupType.fromAPI(data)
    commit('changeGroupType', type)
    return type
  },
  // Fixme 需要支持批量操作
  async deleteGroupTypes ({dispatch}, types) {
    let ids
    if (types instanceof Array) {
      ids = types.map(p => p.id)
    }
    else {
      throw new LError('必须传入数组')
    }
    if (ids.length > 0) {
      return dispatch('getDataFromApi', {
        method: 'delete',
        url: `/shiroApi/group/type/${ids[0]}/force/true`
      }, {root: true})
    }
  },

  // Group
  async getGroups ({dispatch, rootState}, {pagination, filter, sortStack, search, type, all}) {
    if (all) {
      pagination = {
        page: 1,
        rowsPerPage: 500
      }
    }
    // let self = rootState.login.self || {}
    // console.log(self)
    // let orgId = self.institution && self.institution.id
    let params = {}
    params.type = type instanceof Array ? type.join(',') : type || ''
    if (search && search.key === 'name') {
      params.name = search.value
    }
    let {items, amount} = await dispatch('getDataList', {
      pagination,
      sortStack,
      search,
      filter,
      transDict: {level: 'codeLevel'},
      url: `/shiroApi/group/list`,
      params: params
    }, {root: true})
    // console.log('get groups', items)
    return {items: items.map(t => Group.fromAPI(t)), amount: amount}
  },
  // Fixme 新增时必须直接绑定类型
  async setGroup ({dispatch, rootState}, {group, passGroup}) {
    // console.log('role', role)

    // let self = rootState.login.self || {}
    // let orgId = group.insId || self.insId

    // 编辑分组
    let res
    if (group.id) {
      res = await dispatch('getDataFromApi', {
        url: `/shiroApi/group/`,
        method: 'put',
        params: {pid: group.parentId},
        data: {
          'id': group.id,
          'name': group.name,
          'description': group.description,
          'extend': group.extend
          // 'code': group.code,
          // 'codeLevel': group.level,
        }
      }, {root: true})
    }
    // 新建分组
    else {
      res = await dispatch('getDataFromApi', {
        // url: `/shiroApi/group/`,
        url: `/pipe/useradmin/createGroupAndBindTypeOrRole`,
        method: 'put',
        params: {pid: group.parentId},
        data: {
          'usrgrp': {
            // 'id': group.id,
            'name': group.name,
            'description': group.description,
            'extend': group.extend
            // 'code': group.code,
            // 'codeLevel': group.level,
          },
          type: group.typeList.map(t => t.name).join(','),
          roleIds: group.roleList.map(r => r.id),
          ...passGroup
        }
      }, {root: true})
    }
    return res
    /* Group.fromAPI(res) */
  },
  // Fixme 需要支持批量操作
  async deleteGroups ({dispatch}, groups) {
    let ids
    if (groups instanceof Array) {
      ids = groups.map(p => p.id)
    }
    else {
      throw new LError('必须传入数组')
    }
    if (ids.length > 0) {
      return dispatch('getDataFromApi', {
        method: 'delete',
        url: `/shiroApi/group/${ids[0]}/force/false`
      }, {root: true})
    }
  },
  async getUsersByGroup ({dispatch}, {params, group}) {
    let {pagination, sortStack, filter} = params
    let search = {key: 'name', value: params.search.value}
    console.log("1" + params.order);
    if (group && params.order != null) {

      let {items, amount} = await dispatch('getDataList', {
        pagination,
        sortStack,
        filter,
        search,
        url: `/shiroApi/group/${group.id}/userByOrg/list?name=`+params.search.value
      }, {root: true})
      return {items: items.map(item => Person.fromAPI(item)), amount}
    }
    else if (group) {
      let {items, amount} = await dispatch('getDataList', {
        pagination,
        sortStack,
        filter,
        search,
        url: `/shiroApi/group/${group.id}/user/list?name=`+params.search.value
      }, {root: true})
      return {items: items.map(item => Person.fromAPI(item)), amount}
    }
    else {
      throw new LError('未获取到分组ID')
    }
  },
  async groupBindGroupTypes ({dispatch}, {group, types}) {
    if (group) {
      let ps = uniqBy([...group.typeList, ...types], 'name')
      return dispatch('getDataFromApi', {
        url: `/shiroApi/group/${group.id}/bind/type`,
        method: 'put',
        data: {
          usrgrpTypes: ps.map(p => p.name)
        }
      }, {root: true})
    }
    else {
      throw new LError('未获取到分组ID')
    }
  },
  async groupBindRoles ({dispatch}, {group, roles = []}) {
    if (group) {
      let ps = uniqBy([...group.roleList, ...roles], 'id')
      return dispatch('getDataFromApi', {
        url: `/shiroApi/group/${group.id}/bind/role`,
        method: 'put',
        data: {
          roleIds: ps.map(p => p.id)
        }
      }, {root: true})
    }
    else {
      throw new LError('未获取到分组ID')
    }
  },
  async groupUnbindRoles ({dispatch}, {group, roles = []}) {
    if (group && roles instanceof Array && roles.length > 0) {
      let ps = group.roleList.filter(p => roles.every(r => r.id !== p.id))
      return dispatch('getDataFromApi', {
        url: `/shiroApi/group/${group.id}/bind/role`,
        method: 'put',
        data: {
          roleIds: ps.map(p => p.id)
        }
      }, {root: true})
    }
    else {
      throw new LError('未获取到分组ID或角色ID')
    }
  },
  async groupBindUsers ({dispatch}, {group, users = []}) {
    if (group) {
      return dispatch('getDataFromApi', {
        url: `/shiroApi/group/${group.id}/bind/user`,
        method: 'put',
        data: {
          userIds: users.map(p => p.id)
        }
      }, {root: true})
    }
  },
  async groupUnbindUsers ({dispatch}, {group, users}) {
    // Fixme 需要支持批量操作
    if (users instanceof Array && users.length) {
      return dispatch('userUnbindGroups', {user: users[0], groups: [group]})
    }
  },

  // Role
  async getRoles ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      pagination,
      sortStack,
      search,
      filter,
      url: `/shiroApi/role/list`
    }, {root: true})
    return {items: items.map(t => Role.fromAPI(t)), amount: amount}
  },
  async setRole ({dispatch}, role) {
    // console.log('role', role)
    if (role instanceof Role) {
      let res = await dispatch('getDataFromApi', {
        url: '/shiroApi/role/',
        method: 'put',
        data: {
          'id': role.id,
          'name': role.name,
          'description': role.description,
          'shiroStr': role.shiroStr
        }
      }, {root: true})
      return Role.fromAPI(res)
    }
  },
  async deleteRoles ({dispatch}, roles) {
    // Fixme 需要支持批量操作
    if (roles instanceof Array && roles.length) {
      return dispatch('getDataFromApi', {
        url: `/shiroApi/role/${roles[0].id}/force/true`,
        method: 'delete',
        data: {
          ids: roles.map(r => r.id)
        }
      }, {root: true})
    }
  },
  async getUsersByRole ({dispatch}, {params, role}) {
    let {pagination, sortStack, filter, search} = params
    if (role) {
      let {items, amount} = await dispatch('getDataList', {
        pagination,
        sortStack,
        filter,
        search,
        url: `/shiroApi/role/${role.id}/user/list`
      }, {root: true})
      return {items: items.map(item => Person.fromAPI(item)), amount}
    }
    else {
      throw new LError('未获取到角色ID')
    }
  },
  async roleBindPermission ({dispatch}, {role, permissions = []}) {
    if (role) {
      let ps = uniqBy([...role.permissionList, ...permissions], 'id')
      return dispatch('getDataFromApi', {
        url: `/shiroApi/role/${role.id}/bind/permission`,
        method: 'put',
        data: {
          permissionIds: ps.map(p => p.id)
        }
      }, {root: true})
    }
  },
  async roleUnbindPermission ({dispatch}, {role, permission}) {
    if (role && permission) {
      let ps = role.permissionList.filter(p => p.id !== permission.id)
      console.log('filter', ps)
      return dispatch('getDataFromApi', {
        url: `/shiroApi/role/${role.id}/bind/permission`,
        method: 'put',
        data: {
          permissionIds: ps.map(p => p.id)
        }
      }, {root: true})
    }
  },
  async roleBindUsers ({dispatch}, {role, users = []}) {
    if (role) {
      return dispatch('getDataFromApi', {
        url: `/shiroApi/role/${role.id}/bind/user`,
        method: 'put',
        data: {
          userIds: users.map(p => p.id)
        }
      }, {root: true})
    }
  },
  async roleUnbindUser ({dispatch}, {role, user}) {
    return dispatch('userUnbindRole', {user, role})
    // if (role) {
    //   let ps = role.permissionList.filter(p => p.id !== permission.id)
    //   console.log('filter', ps)
    //   return dispatch('getDataFromApi', {
    //     url: `/shiroApi/role/${role.id}/bind/permission`,
    //     method: 'put',
    //     data: {
    //       permissionIds: ps.map(p => p.id)
    //     }
    //   }, {root: true})
    // }
  },
  async roleBindGroups ({dispatch}, {role, groups = []}) {
    if (role) {
      return dispatch('getDataFromApi', {
        url: `/shiroApi/role/${role.id}/bind/group`,
        method: 'put',
        data: {
          groupIds: groups.map(p => p.id)
        }
      }, {root: true})
    }
  },
  async roleUnbindGroups ({dispatch}, {role, groups}) {
    return dispatch('groupUnbindRoles', {group: groups[0], role})
  },
  async getGroupsByRole ({dispatch}, {params, role}) {
    let {pagination, sortStack, filter, search} = params
    if (role) {
      let {items, amount} = await dispatch('getDataList', {
        pagination,
        sortStack,
        filter,
        search,
        url: `/shiroApi/role/${role.id}/group/list`
      }, {root: true})
      return {items: items.map(item => Group.fromAPI(item)), amount}
    }
    else {
      throw new LError('未获取到角色ID')
    }
  },

  // Permission
  async getPermissions ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      pagination,
      sortStack,
      search,
      filter,
      transDict: {type: 'resourceType'},
      url: `/shiroApi/permission/list`
    }, {root: true})
    return {items: items.map(t => Permission.fromAPI(t)), amount: amount}
  },
  async setPermission ({dispatch}, permission) {
    // console.log('role', role)
    if (permission instanceof Permission) {
      let res = await dispatch('getDataFromApi', {
        url: '/shiroApi/permission/',
        method: 'put',
        data: {
          'id': permission.id,
          'name': permission.name,
          'description': permission.description,
          'shiroStr': permission.shiroStr,
          'resourceType': permission.type
        }
      }, {root: true})
      return Permission.fromAPI(res)
    }
  },
  async deletePermissions ({dispatch}, permissions) {
    // Fixme 需要支持批量操作
    if (permissions instanceof Array && permissions.length) {
      return dispatch('getDataFromApi', {
        url: `/shiroApi/permission/${permissions[0].id}/force/true`,
        method: 'delete',
        data: {
          ids: permissions.map(r => r.id)
        }
      }, {root: true})
    }
  },

  // Institution
  async getInstitutions ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      pagination,
      sortStack,
      search,
      filter,
      url: `/shiroApi/group/inst/list`
    }, {root: true})
    return {items: items.map(t => Institution.fromAPI(t)), amount: amount}
  },
  async setInstitution ({dispatch}, ins) {
    // console.log('role', role)
    if (ins instanceof Institution) {
      let res = await dispatch('getDataFromApi', {
        url: '/shiroApi/group/inst',
        method: 'put',
        data: {
          'id': ins.id,
          'name': ins.name,
          'description': ins.description,
          'code': ins.code
        }
      }, {root: true})
      return Institution.fromAPI(res)
    }
  },
  async deleteInstitutions ({dispatch}, institutions) {
    // Fixme 需要支持批量操作
    if (institutions instanceof Array && institutions.length) {
      return dispatch('getDataFromApi', {
        url: `/shiroApi/group/inst/${institutions[0].id}/force/true`,
        method: 'delete',
        data: {
          ids: institutions.map(r => r.id)
        }
      }, {root: true})
    }
  },
  async findPassGroup ({dispatch}, id) {
    let url = '/passApi/group/info/all?page=0&size=10'
    try {
      let res = null
      res = await axios.post(url, {
        'searchParam': {
          'orgId': {
            'order': 'ASC',
            'operators': [
              {
                'keyword': id,
                'operator': 'LIKE',
                'mathType': 'NONE'
              }
            ],
            'index': 1
          }
        }
      })
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getPassGroups ({dispatch}, {pagination, filter, search, sortStack}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/passApi/group/info/all',
      pagination,
      filter: {...filter},
      search,
      sortStack
    }, {root: true})
    return {items: items, amount: amount}
  },
  async getPersonPassGroups ({dispatch}, {pagination, filter, search, sortStack}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/passObjectApi/group/info/all',
      pagination,
      filter: {...filter},
      search,
      sortStack
    }, {root: true})
    return {items: items, amount: amount}
  },
  async getOrgListByName ({dispatch}, {name, pagination, type, id}) {
    let url = '/shiroApi/group/list?page=' + (pagination.page - 1) + '&size=' + pagination.rowsPerPage + '&type=' + type + '&name=' + ((name === undefined) ? '' : name) + '&id=' + ((id === undefined) ? '' : id)
    try {
      let res = null
      res = await axios.post(url, {})
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async transformData ({dispatch}, params) {
    let url = '/shiroApi/auth/thirdpart/forceParse?pipe=uestc-portal'
    try {
      let res = null
      res = await axios.post(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 上传文件 */
  async uploadApk ({dispatch}, {formData,version}) {
    let url = '/pipe/apk/upload?version='+version
    try {
      let res = null
      res = await axios.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}})
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async unbindUsers ({dispatch}, loginId) {
    let url = '/shiroApi/admin/unbindWechat?loginId='+loginId
    try {
      let res = null
      res = await axios.post(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getPartnerTemplate () {
    return encodeURI("https://smaco2.uestc.edu.cn/pipe/files/合作用户批量导入模版.xlsx")
  },
  async getVehicleFileTemplate(){
    return encodeURI("https://smaco2.uestc.edu.cn/pipe/files/合作单位车辆批量导入模版.xlsx")
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
